<template>
  <v-container class="my-3 px-5">
    <v-row class="my-2" justify="center">
      <v-col>
        <v-btn color="info" @click="$router.go(-1)" class="my-3"
          ><v-icon small class="mr-1">mdi-arrow-left</v-icon> ย้อนกลับ</v-btn
        >
        <h1>เนื้อหาบทเรียน</h1>
      </v-col>
    </v-row>
    <v-card class="mx-auto p-10">
      <div class="item">
        <div class="player">
          <video-player
            oncontextmenu="return false"
            class="vjs-custom-skin"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            customEventName="customstatechangedeventname"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onPlayerEnded($event)"
            @waiting="onPlayerWaiting($event)"
            @playing="onPlayerPlaying($event)"
            @timeupdate="onPlayerTimeupdate($event)"
            @statechanged="playerStateChanged($event)"
            @ready="playerReadied"
          >
          </video-player>
        </div>
      </div>
    </v-card>
    <v-row class="mt-3">
      <v-btn
        @click="changeVideo(lesson, index)"
        class="ma-1"
        :color="active === index ? 'primary' : ''"
        v-for="(lesson, index) in lessons.videoData"
        :key="lesson.lessonId"
        >วิดีโอที่ {{ index + 1 }}</v-btn
      >
    </v-row>
    <v-row class="mt-5">
      <h5 class="mt-3">ไฟล์ประกอบการสอน</h5>
      <v-col cols="12">
        <v-btn
          @click="viewFiles(file, index)"
          color="info"
          class="ml-3 mt-2"
          v-for="(file, index) in filesData"
          :key="file.fileId"
          >{{ file.name }}</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <h5 class="mt-5">เนื้อหาเพิ่มเติม</h5>
      <v-col cols="12" v-html="lessons.lessonData[0].content"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import "@/mixins/generalMixin";
export default {
  name: "ViewCourse",
  data() {
    return {
      active: 0,
      lessons: [],
      filesData: [],
      playerOptions: {
        // videojs options
        height: 500,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "http://lms.appdii.com/videos/test.m4v",
          },
        ],
        poster: "",
      },
    };
  },
  mounted() {
    console.log("this is current player instance object", this.player);
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    viewFiles(file) {
      window.open(this.filePath(file.name, "files"), "_blank");
    },

    onPlayerTimeupdate(player) {
      console.log("time", player);
    },

    onPlayerPlaying(player) {
      console.log("playing", player);
    },

    changeVideo(lesson, index) {
      this.active = index;
      console.log(this.videoPath(lesson.videoName, "video"));
      this.playerOptions.sources[0].src = this.videoPath(
        lesson.videoName,
        "video"
      );
    },
    // listen event
    onPlayerPlay(player) {
      console.log("player play!", player);
    },
    onPlayerPause(player) {
      console.log("player pause!", player);
    },

    // ...player event

    // or listen state event
    playerStateChanged(playerCurrentState) {
      console.log("player current update state", playerCurrentState);
    },

    // player is ready
    playerReadied(player) {
      console.log("the player is readied", player);
      // you can use it to do something...
      // player.[methods]
    },
    getLesson() {
      let formData = new FormData();
      formData.append("lessonId", this.$route.query.lessonId);

      this.$http
        .post(`${process.env.VUE_APP_API_PATH}/lesson/getLesson.php`, formData)
        .then((res) => {
          this.lessons = res.data;
          console.log("res", res.data);
          this.playerOptions.sources[0].src = this.videoPath(
            this.lessons.videoData[0].videoName,
            "video"
          );

          this.playerOptions.poster = this.imgPath(
            this.lessons.lessonData[0].lessonImage,
            "lesson"
          );

          this.filesData = res.data.filesData;

          console.log("lesson", this.lessons);
          console.log("filesData", this.filesData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getLesson();
  },
};
</script>

<style>
@import "./custom-theme.css";
</style>
